<div id="money-movement-container" class="money-movement-container">
    <div id="mm-content" [ngClass]="featureFlagsReady ? '' : 'visibility: hidden'">
        <router-outlet></router-outlet>
        <mm-cancel-modal-v2></mm-cancel-modal-v2>
        <mm-file-picker-modal></mm-file-picker-modal>
    </div>
</div>
